document.addEventListener('DOMContentLoaded', function () {
  const redirectData = document.getElementById('redirect-data');
  const redirectUrl = redirectData?.dataset?.url;

  if (!redirectUrl) return;

  document.querySelectorAll('.product__media-item').forEach(img => {
    img.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = redirectUrl;
    });
  });
});